import { BasicEmployeeDetails } from './basicemployeedetails.model'

export class WinHRPagesUserMapping {
  ID: number
  AppPageID: number
  AppPageName: string;
  EmpCode: number
  HasFullAccess: boolean
  AddingPermission: boolean
  DeletingPermission: boolean
  EditingPermission: boolean
  UpdatedBy: string
  UpdateDate: Date
  CreatedDate: Date
  CretedBy: string
  ReadOnlyPermission:boolean
}

